<script lang="ts">
  import type { SvelteComponent } from "svelte";
  import DoneIcon from "../icons/DoneIcon.svelte";
  import ErrorIcon from "../icons/ErrorIcon.svelte";
  import InfoIcon from "../icons/InfoIcon.svelte";
  import WarningIcon from "../icons/WarningIcon.svelte";
  export let type: "error" | "notice" | "success" | "warning";
  export let message: string;
  let icon: SvelteComponent | any | undefined = undefined;
  switch (type) {
    case "error":
      icon = ErrorIcon;
      break;
    case "notice":
      icon = InfoIcon;
      break;
    case "success":
      icon = DoneIcon;
      break;
    case "warning":
      icon = WarningIcon;
      break;
  }
</script>

<div class="Alert Alert--{type}">
  {#if icon}
    <svelte:component this={icon} width="24px" height="24px" color="#fff" />
  {/if}
  {message}
</div>

<style type="text/scss">
  @import "../../scss/config.scss";

  .Alert {
    padding: 12px 16px;
    display: flex;
    line-height: 20px;
    align-items: center;
    border-radius: 0;
    color: $color-white;
    :global(svg) {
      margin-right: 12px;
    }
    &--error {
      background: $color-error;
    }
    &--success {
      background: $color-success;
    }
    &--warning {
      background: $color-warning;
    }
    &--notice {
      background: $color-notice;
    }
  }
</style>
